import React, { Component } from "react";
import axios from "axios";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

import { Card, Grid, TextField, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

export default class AddUpdatePage extends Component {
  state = {
    description: "",
    advantages: [""],
    proposal: [""],

    notification: {
      open: false,
      color: "success",
      message: "",
    },
  };

  componentDidMount() {
    if (init() !== "success") return;

    axios
      .get(Constants.getUrls.getAbacusSchool)
      .then((res) => {
        if (res.data.status === "success" && res.data.data?.length) {
          const d = res.data.data[0];

          this.setState({
            description: d.abacus_school_description || "",
            advantages: d.advantages?.length ? d.advantages : [""],
            proposal: d.abacus_proposal_description?.length ? d.abacus_proposal_description : [""],
          });
        }
      })
      .catch(() => {
        this.showNotification("error", "Failed to load data");
      });
  }

  /* ---------------- HELPERS ---------------- */

  showNotification = (color, message) => {
    this.setState({
      notification: {
        open: true,
        color,
        message,
      },
    });

    setTimeout(() => {
      this.setState({
        notification: { open: false, color: "", message: "" },
      });
    }, 1500);
  };

  handleArrayChange = (type, index, value) => {
    const updated = [...this.state[type]];
    updated[index] = value;
    this.setState({ [type]: updated });
  };

  addField = (type) => {
    this.setState({
      [type]: [...this.state[type], ""],
    });
  };

  removeField = (type, index) => {
    const updated = this.state[type].filter((_, i) => i !== index);
    this.setState({
      [type]: updated.length ? updated : [""],
    });
  };

  /* ---------------- SUBMIT ---------------- */

  handleSubmit = () => {
    const payload = {
      abacus_school_description: this.state.description,
      //   advantages: this.state.advantages.filter(Boolean),
      proposal: this.state.proposal.filter(Boolean),
    };

    axios
      .post(Constants.postUrls.createAbacusSchool, payload)
      .then((res) => {
        if (res.data.status === "success") {
          this.showNotification("success", res.data.message);
        }
      })
      .catch(() => {
        this.showNotification("error", "Something went wrong");
      });
  };

  /* ---------------- UI ---------------- */

  render() {
    const { description, advantages, proposal, notification } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Update Abacus School
              </MDTypography>
            </MDBox>

            <MDBox p={3}>
              <Grid container spacing={3}>
                {/* DESCRIPTION */}
                <Grid item xs={12}>
                  <MDTypography variant="button" fontWeight="bold">
                    Description
                  </MDTypography>
                  <SunEditor
                    height="200px"
                    setContents={description}
                    onChange={(content) => this.setState({ description: content })}
                    setDefaultStyle="font-family: Arial; font-size: 16px;"
                    setOptions={{
                      buttonList: [
                        ["undo", "redo"],
                        ["font", "fontSize"],
                        ["bold", "underline", "italic"],
                        ["fontColor", "hiliteColor"],
                        ["align", "list"],
                        ["table", "link", "image", "video"],
                        ["preview", "print"],
                        ["removeFormat"],
                      ],
                      defaultTag: "div",
                      showPathLabel: false,
                    }}
                  />
                </Grid>

                {/* ADVANTAGES */}
                {/* <Grid item xs={12}>
                  <MDTypography variant="button" fontWeight="bold">
                    Advantages
                  </MDTypography>

                  {advantages.map((item, index) => (
                    <Grid container spacing={1} key={index} alignItems="center">
                      <Grid item xs={11}>
                        <TextField
                          fullWidth
                          value={item}
                          onChange={(e) =>
                            this.handleArrayChange("advantages", index, e.target.value)
                          }
                        />
                      </Grid>
                      <Grid item xs={1}>
                        <IconButton onClick={() => this.removeField("advantages", index)}>
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}

                  <MDButton startIcon={<AddIcon />} onClick={() => this.addField("advantages")}>
                    Add Advantage
                  </MDButton>
                </Grid> */}

                {/* PROPOSAL */}
                <Grid item xs={12}>
                  <MDTypography variant="button" fontWeight="bold">
                    Proposal
                  </MDTypography>

                  {proposal.map((item, index) => (
                    <Grid container spacing={1} key={index} alignItems="center">
                      <Grid item xs={11}>
                        <TextField
                          fullWidth
                          value={item}
                          onChange={(e) =>
                            this.handleArrayChange("proposal", index, e.target.value)
                          }
                          style={{ marginTop: "10px" }}
                        />
                      </Grid>
                      <Grid item xs={1}>
                        <IconButton onClick={() => this.removeField("proposal", index)}>
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}

                  <MDButton startIcon={<AddIcon />} onClick={() => this.addField("proposal")}>
                    Add Proposal
                  </MDButton>
                </Grid>

                {/* SUBMIT */}
                <Grid item xs={12} align="right">
                  <MDButton color="info" onClick={this.handleSubmit}>
                    Update
                  </MDButton>
                </Grid>
              </Grid>
            </MDBox>
          </Card>

          <MDSnackbar
            open={notification.open}
            color={notification.color}
            icon="notifications"
            title="Status"
            content={notification.message}
            dateTime="Just now"
          />
        </MDBox>
      </DashboardLayout>
    );
  }
}
